import { useTranslation } from 'react-i18next';

type AccountCardProps = {
  accessCode: string;
  currency: string;
};

export default function AccountCard({ accessCode, currency }: AccountCardProps) {
  const { t } = useTranslation();

  const rows = [
    { icon: 'ri-hashtag', label: t('dashboard.accountCode'), value: accessCode },
    { icon: 'ri-coins-line', label: t('dashboard.currencyLabel'), value: currency },
  ];

  return (
    <div className="rounded-lg border border-background-200 bg-background-100 p-6">
      <h2 className="font-heading text-base font-semibold text-foreground-950">
        {t('dashboard.account')}
      </h2>

      <div className="mt-4 flex items-center gap-2 rounded-md bg-primary-50 px-3 py-2.5">
        <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary-500 text-background-50">
          <i className="ri-checkbox-circle-line text-xs"></i>
        </span>
        <span className="text-sm font-semibold text-primary-800">
          {t('dashboard.statusActive')}
        </span>
      </div>

      <dl className="mt-4 divide-y divide-background-200">
        {rows.map((row) => (
          <div key={row.icon} className="flex items-center justify-between gap-4 py-3">
            <dt className="flex items-center gap-2 text-sm text-foreground-600">
              <i className={`${row.icon} text-base text-foreground-400`}></i>
              {row.label}
            </dt>
            <dd className="text-sm font-semibold text-foreground-950">{row.value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}